import React, { useState, useEffect } from "react";
import {
  Typography,
  Stack,
  Box,
} from "@mui/material";
import ReactApexChart from "react-apexcharts";
import "./dropoutchart.scss";
import { useQuery } from "@apollo/client";

import { AuthContext } from "../../../Context/AuthContext";
import { translateLauguage } from "../../../Function/Translate";

import { GET_ALL_DROP_OUT_CHART } from "../../../Schema/Dashboard";

import LoadingPage from "../../Include/LoadingPage";

export default function DropOutChart({ academicYearId, academicYearName }) {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [totalData, setTotalData] = useState([]);

  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(GET_ALL_DROP_OUT_CHART, {
    variables: {
      academicYearId: academicYearId ?? null,
    },
    onCompleted: ({ getAllDropOutChart }) => {
      setTotalData(getAllDropOutChart);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const schoolData = totalData?.map((e) => {
    return language === "en" ? e?.schoolNameEn : e?.schoolName;
  });

  const totalStudent = totalData?.map((e) => e?.totalStudent);
  const totalFemale = totalData?.map((e) => e?.female);

  // const maxSeriesData = Math.max(...(totalStudent?.length ? totalStudent : []));

  useEffect(() => {
    refetch();
  }, [academicYearId]);

  const state = {
    options: {
      chart: {
        type: "bar",
        height: 350,
        fontFamily: "Khmer OS Siemreap",
        stacked: false,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%",
          endingShape: "rounded",
          dataLabels: {
            position: "top", // top, center, bottom
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -25,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
        formatter: function (val, opts) {
          if (val > 0) {
            return val;
          } else {
            return "0";
          }
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: schoolData,
        labels: {
          rotate: -45, // Rotates labels to -45 degrees
          rotateAlways: true, // Ensures rotation applies
          maxHeight: 150,
        },
      },
      yaxis: {
        // max: maxSeriesData + 5,
        labels: {
          style: {
            fontFamily: "Siemreap",
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            if (val > 0) {
              return val + " នាក់";
            } else {
              return 0 + " នាក់";
            }
          },
        },
      },
      fill: {
        opacity: 1,
      },
    },
    series: [
      {
        name: t("total_student"),
        data: totalStudent,
        color: "#F44236",
      },
      {
        name: t("total_female"),
        data: totalFemale,
        color: "#FEC009",
      },
    ],
  };

  return (
    <Box className="total-drop-out-chart">
      <Stack direction="row" alignItems="center" justifyContent="center">
        <Typography
          className={language === "en" ? "chart-title" : "chart-title-kh"}
        >
          {t("total_drop_out_chart")}{academicYearName && language === "kh" ? `ឆ្នាំសិក្សា ${academicYearName}` : ` ${academicYearName}`}
        </Typography>
      </Stack>
      {
        loading ? <LoadingPage /> :
          <div id="chart">
            <ReactApexChart
              options={state.options}
              series={state.series}
              type="bar"
              height={400}
            />
          </div>
      }

    </Box>
  );
}
